import { AnswerUser } from "../../../Question";
import React from "react";
import AnswerReference from "../AnswerReference";
import styles from "./index.module.scss";

interface QuestionAnswerProps {
    isCorrect?: boolean;
    reference: any;
}

export default function QuestionAnswer({
    reference,
    isCorrect
}: QuestionAnswerProps) {
    return (
        <div className={styles.root}>
            <div className={styles.label}>
                学生答案
                {typeof isCorrect === "boolean" && (
                    <span
                        className={isCorrect ? styles.correct : styles.wrong}
                    />
                )}
            </div>
            <AnswerUser />

            {reference && (
                <>
                    <div className={styles.line} />

                    <div className={styles.label2}>正确答案</div>
                    <AnswerReference reference={reference} />
                </>
            )}
        </div>
    );
}
